<template>
    <div class="login-box">
        <div class="ms-login">
            <div class="login-logo">
                <img src="@p/assets/images/logo-bg.png" alt="logo">
            </div>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="ms-content">
                <h2>用戶登錄</h2>
                <el-form-item prop="username">
                    <input 
                    :style="bgIndex === 'username' ? 'background-image: url('+require('@p/assets/images/icon/user1.png')+')' :''"
                    class="outline" 
                    @blur="inputBlur('username')"  
                    @focus="inputfocus('username')" 
                    type="text" 
                    v-model="ruleForm.username" 
                    placeholder="username" 
                    autocomplete="username"
                    @keyup.enter='setPassFocus()'>
                </el-form-item>
                <el-form-item prop="password">
                    <input 
                    class="outline"
                    :style="bgIndex === 'password' ? 'background-image: url('+require('@p/assets/images/icon/lock1.png')+')' :''"
                    @blur="inputBlur('password')"  
                    @focus="inputfocus('password')" 
                    type="password"
                    autocomplete="current-password"
                    placeholder="password" 
                    ref="passFocus" 
                    v-model="ruleForm.password"
                    @keyup.enter="submitForm('ruleForm')">
                </el-form-item>
                <div class="save-pass"><el-checkbox v-model="checked">記住密碼</el-checkbox></div>
                <div class="login-btn">
                    <el-button type="primary" :loading="loading" @click="submitForm('ruleForm')">登錄</el-button>
                </div>
            </el-form>
        </div>
        <div class="Copyright">Copyright © 2020 LMS{{bottomNumber}}</div>
    </div>
</template>

<script>
const Base64 = require('js-base64').Base64;
import config from '@/config';
import storage from '@/utils/storage.js'
    export default {
        data(){
            return {
                loading:false,
                checked:false,
                bgIndex:'',
                ruleForm: {
                    username: '',    //hayden.h,Favor.p
                    password: '',
                },
                rules: {
                    username: [
                        { required: true, message: '請輸入用戶名', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: '請輸入密碼', trigger: 'blur' }
                    ]
                },
                bottomNumber: config.bottomNumber
            }
        },
        created(){
            if(storage.localGet('token')){
                this.$router.push({path:'/'});
            }
            if(storage.localGet('record')){
                let record = storage.localGet('record');
                this.ruleForm.username = record.username;
                this.ruleForm.password = Base64.decode(record.password);
                this.checked = true;
            }
        },
        methods: {
            submitForm(formName) { //登录
                this.$refs[formName].validate((valid) => {
                    this.loading=true;
                    if (valid) {
                        let username = this.ruleForm.username;
                        let password = this.ruleForm.password;
                        this.$http.home.login({username,password})
                            .then((res) =>{
                                storage.localSet('username',username)
                                storage.localSet('token',res.data.access_token)
                                let basePassword = Base64.encode(password)
                                let record = {username: username,password: basePassword}
                                if(this.checked){
                                    storage.localSet('record',record)
                                }else{
                                    storage.localRemove('record')
                                }
                                this.$store.commit('setUsername',username)
                                if(this.$route.query.path){ //登录后跳转课程详情
                                    this.$router.push({path:'/home/lessons/study',query:{id:this.$route.query.path, title: this.$route.query.title}})
                                }else{
                                    this.$router.push({path:'/'});
                                }
                                this.loading=false;
                                this.$store.commit('setScrollState',0); //首页header默认透明
                                this.$store.commit('emptyHomeKeep');
                            })
                            .catch((err) =>{
                                this.loading=false;
                                this.$message.error(err.response.data.error_description);
                            })
                    } else {
                        this.loading=false;
                        return false;
                    }
                });
            },
            inputBlur(v){
                this.bgIndex='';
            },
            inputfocus(v){
                this.bgIndex=v;
            },
            setPassFocus(){
                this.$refs.passFocus.focus()
            }
        }
    }
</script>

<style lang="less" scoped>
.login-box{
    position: relative;
    width:100%;
    height:100%;
    overflow: hidden;
    background: url(../../assets/images/login-bg.png) no-repeat;
    background-size: cover;
    background-position: 50%;
    .ms-login{
        position: absolute;
        z-index: 2;
        left:50%;
        top:50%;
        width:964px;
        height: 460px;
        margin:-230px 0 0 -482px;
        background: rgba(255,255,255, 0.3);
        overflow: hidden;
        .login-logo{
            float: left;
        }
        .ms-content{
            width: 482px;
            height: 100%;
            float: left;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-flow: column;
            background: #ffffff;
            h2{
                color: #333333;
                font-size:33px;
                font-weight:400;
                margin-bottom: 36px;
            }
            .el-form-item{
                margin: 0;
            }
            input{
                border: 0;
                width:368px;
                height:40px;
                border-radius:20px;
                padding-left: 36px;
                box-sizing: border-box;
                background:rgba(234,234,243,1) url(../../assets/images/icon/user.png) no-repeat;
                background-position: 15px 50%;
                background-size: 14px 14px;
                display: block;
                color: #333333;
            }
            input[type="password"]{
                margin-top: 24px;
                background:rgba(234,234,243,1) url(../../assets/images/icon/lock.png) no-repeat;
                background-position: 15px 50%;
                background-size: 14px 14px;
            }
            .save-pass{
                width: 100%;
                padding: 0 57px;
                box-sizing: border-box;
                margin: 24px 0;
            }
            .login-btn{
                width:368px;
                height:40px;
                opacity:1;
                border-radius:4px;
                button{
                    width:368px;
                    height:40px;
                    background:rgba(77,142,246,1);
                    font-size:16px;
                }
            }
        }
    }
    .Copyright{
        position: absolute;
        bottom: 20px;
        width: 100%;
        text-align: center;
        font-size: 12px;
        color: #333333;
    }
}
</style>
